import React from 'react';
import { HourglassIcon } from 'lucide-react';
import { Badge } from './Badge';
export function TbdBadge() {
  return <Badge tone="amber" icon={HourglassIcon} data-id="element-1162" data-mp="5dl0dsbfxc8m">
      TBD
    </Badge>;
}